// Module
var code = `<customer-breadcrumbs mode="\$ctrl.mode"></customer-breadcrumbs>
<customer-profile-header mode="\$ctrl.mode"></customer-profile-header>
<section class="box">
  <ng-transclude></ng-transclude>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/common/customer-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;